import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: theme.palette.grey[300],
    },
  },
  selected: {
    backgroundColor: theme.palette.primary.main + ' !important',
    color: theme.palette.primary.contrastText,
  },
})
export default styleOverride
